import React, { useEffect, useState } from "react";
import ReactModal from 'react-modal';

import axios from "axios";

import Validate from '../../../helpers/validate';
import authHeader from '../../../services/auth-header';
import { TextControl, SelectControl } from '../Controls';
import DocumentManager from "../DocumentManager";

function DetailDriverModal(props) {

    const [driverNumber, setDriverNumber] = useState();
    const [errorMessage, setErrorMessage] = useState({});

    useEffect(() => {
        if (props.isOpen) {
            setDriverNumber(props.currentDriver.driverNumber);
        }
    }, [props.isOpen])

    async function handleDriverNumberUpdate() {
        const validate = new Validate();
        const message = {};
        message.driverNumber = validate.init(driverNumber, {
            maxLength: {
                value: 10,
                message: 'The maximum length possible is 10 characters'
            },
            minLength: {
                value: 1,
                message: 'The minimum length possible is 1 character'
            },
            integer: {
                message: 'The driver Id can only be a number'
            }
        }).getHTML();
        setErrorMessage(message);

        if (validate.status) {
            await axios.put(process.env.REACT_APP_API_URL + `api/admin/updateDriverNumber/${props.currentDriver.memberId}`, {
                driverNumber
            }, {
                headers: authHeader()
            });
            props.updateTable();
        }
    }

    function handleFocus(event) {
        const element = event.target.id,
            messages = errorMessage;
        messages[element] = null;
        setErrorMessage(messages);
    }

    function clearControls() {
        setDriverNumber('');
    }

    return (
        <ReactModal isOpen={props.isOpen} style={{ overlay: { zIndex: '999' } }}>
            <div className="container">
                <div className="row">
                    <div className="col s11 left hide-on-small-only" style={{ fontVariant: 'small-caps', fontFamily: 'Raleway', fontSize: '2rem' }}>
                        Driver Details - {props.currentDriver.fullName}
                    </div>
                    <div className="col s1 right">
                        <a onClick={() => {
                            clearControls();
                            props.onClose();
                        }} className="btn-floating waves-effect waves-light black white-text"><i className="material-icons">close</i></a>
                    </div>
                </div>
                <hr />
                <CustomRow>
                    <div className="input-field col s8">
                        <input type="text" value={props.currentDriver.workExperience} id="workExperience" />
                        <label className="active" htmlFor="workExperience">Work Experience</label>
                    </div>
                </CustomRow>
                <CustomRow>
                    <div className="input-field col s8">
                        <TextControl id="driverNumber" type="driverNumber" value={driverNumber} inputEventHandler={setDriverNumber} focusEventHandler={handleFocus} maxlength="10" />
                        <label className="active" htmlFor="driverNumber">Driver Number</label>
                        <span data-assigned="driverNumber" className="helper-text red-text text-darken-1">{errorMessage.driverNumber}</span>
                    </div>
                </CustomRow>
                <CustomRow>
                    <div className="input-field col s8">
                        <a onClick={handleDriverNumberUpdate} style={{ width: '100%', fontFamily: 'Raleway', fontSize: '1rem', backgroundColor: 'black', marginTop: '30px' }} className="waves-effect waves-light btn z-depth-0 white-text">SAVE DRIVER ID</a>
                    </div>
                </CustomRow>
                <DocumentManager id={`driver-${props.currentDriver.driverId}`} driverId={props.currentDriver.driverId} />
            </div>
        </ReactModal>
    );
}

function CustomRow(props) {
    return (
        <div className={`row ${props.className}`}>
            <div className="col s2"></div>
            {props.children}
            <div className="col s2"></div>
        </div>
    );
}

export default DetailDriverModal;